export enum EnvironmentStatus {
    Loading = 'Loading',
    HttpFailure = 'HttpFailure',
    ContentMissing = 'ContentMissing',
}
